import React, {useEffect} from 'react';
import {
    execute,
    init,
    resetState,
  setSelectedPackage, saveToHistory, toggleIsShowMoreDetails
} from "app/Components/Block/IdfSurfingPackageExpansionBlock/IdfSurfingPackageExpansionSlice";
import {connect} from "react-redux";
import SalePackages from "app/Components/Block/SalePackagesBlock/SalePackages";
import BottomButtons from 'app/Components/Block/IdfSaleBlock/Constans/BottomButtons';
import {
  createReportIdfPackageExtensionPageDisplayed,
  createReportIdfPackageExtensionPurchase
} from 'app/utilities/reports/createReport';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import {iconsType} from 'app/constans/salePackageEnum';
import Image from 'app/Components/Shared/Image/image';
const SelectionStep = (props) => {
    const {mainTitle, secondaryTitle, planSelectionTitle} = props.iContent;
    const {packages, currentPackage} = props.idfSurfingPackageExpansion;

    const dwhReport = () =>{
      createReportIdfPackageExtensionPageDisplayed(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber)
    }

  useEffect(() => {
    props.saveToHistory('selection');
    dwhReport();
  }, []);

    const onSelectedPackages = (selectedPackage) => {
        console.log(selectedPackage)
        props.setSelectedPackage(selectedPackage)
    };

    const handleClickContinue = async () => {
      createReportIdfPackageExtensionPurchase(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfSurfingPackageExpansion.selectedPackage?.packageObj?.offerID?.value
      );

      await props.execute({
            socBlockId: props.idfSurfingPackageExpansion.selectedPackage.addonName,
            subscriberNo: props.userData?.loginData?.userDetails?.contactNumber,
            socToRemove: props.idfSurfingPackageExpansion.currentPackage.addonName
        });
    }
   return (
<>
    <div className={'top-content'}>
        <div className={'top-text-content'}>
            <span className={"main-title"}>{mainTitle?.value}</span>
            <span className={"secondary-title"}>{secondaryTitle?.value}</span>
        </div>

      <div className={'card'}>
        <div className={'tag'}>
          <span className={'tag-label'}>צה"ל</span>
        </div>
        <div className={'top-card-content'}>
          <div className={'title-row'}>
            <span className={'card-title'}>חבילת הגלישה שלך</span>
            <span className={'card-sub-title'}>מנוי {props.userData.loginData.userDetails.contactNumber}</span>
          </div>
        </div>
        <div className={'detail-row'}>
          <Image className={'detail-icon'} src={require('../images/internet.svg')} alt={"info"} />
          <span className={'detail'}>
                          חבילת בסיס {props.idfSurfingPackageExpansion?.currentPackage?.dataType} {props.idfSurfingPackageExpansion?.currentPackage?.dataSize}
                      </span>
        </div>
        <div className={'detail-row'}>
          <Image className={'detail-icon'} src={require('../images/wallet.svg')} alt={"info"} />
          <span className={'detail'}>
                        עלות חודשית {props.idfSurfingPackageExpansion?.currentPackage?.packageObj?.price?.value} שח
                        </span>
        </div>


  {props.idfSurfingPackageExpansion?.currentPackage?.packageObj?.extraFeatures?.expandedValue?.length > 0 &&
    <div className={'extra-features'}>
    <button
      className={`more-details-button`}
      onClick={() => props.toggleIsShowMoreDetails()}>
      למידע נוסף
      <span
        className={`arrow ${props.idfSurfingPackageExpansion?.isShowMoreDetails ? 'arrow-up' : 'arrow-down'}`}>
        <span className="left-bar"></span>
        <span className="right-bar"></span>
      </span>
    </button>

  {props.idfSurfingPackageExpansion?.isShowMoreDetails &&
    props.idfSurfingPackageExpansion?.currentPackage?.packageObj?.extraFeatures?.expandedValue?.map((feature) => (
      feature?.featureList?.expandedValue.map((item, i) => (
        console.log(item),
        <div key={i} className="feature">
          {item?.icon.value && <Image src={require(`../../SalePackagesBlock/images/${iconsType[item.icon.value]}.svg`)} alt={`${iconsType[item.icon.value]} +  icon`} />}
          {item?.featureLink.value ? (
            <a href="#" onClick={(e) => {
              e.preventDefault();
              buildUrlAndOpenWindow(item.featureLink.value);
            }}>
              {item?.text.value}
            </a>
          ) : (
            <span className={'feature-text'}
                  style={{
                    fontWeight: item?.isBoldText.value ? 'bold' : 'regular'
                  }}>
              {' '}
              {item?.text?.value}{' '}
            </span>
          )}
        </div>
      ))
    ))
  }
</div>
  }
      </div>
    </div>

  <div className={'bottom-content'}>
    <div className={'title-container'}>
      <span className={'main-title'} dangerouslySetInnerHTML={{__html: planSelectionTitle?.value}} />
    </div>
    <SalePackages
      packages={{
        expandedValue: packages?.map((item) => item.packageObj),
        isAbroadPackages: false
      }}
      isSwiper={true}
      isHideButton={true}
      onSelectedPackages={onSelectedPackages}
      isIdf={true}
    />

  </div>
  <BottomButtons onClickNavigation={handleClickContinue} continueText={'אישור וסיום'}
                 canContinue={props.idfSurfingPackageExpansion.selectedPackage !== null} />

</>
   )
};

const mapStateToProps = (state) => {
  return {
    idfSurfingPackageExpansion: state.IdfSurfingPackageExpansion,
    userData: state.authentication
  }
};

const mapDispatchToProps = {
  resetState,
  setSelectedPackage,
  init,
  execute,
  saveToHistory,
  toggleIsShowMoreDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionStep);
